// extracted by mini-css-extract-plugin
export default {"wrapper":"Occupancy-module__wrapper___neX_2"};